import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7wsuimtos5: FaireBrandEntity = {
  token: "b_7wsuimtos5",
  type: "brand",
  name: "SM Beauty LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/4e0ba973fba0ea037e91fb13ca16b76029209a59ee9ea09816ff9bc28dbec5a7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/72c991a49ff3326d9897bb5e9a653543b3d6c6f54157c3bd185e22eb03a1e81e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4e0ba973fba0ea037e91fb13ca16b76029209a59ee9ea09816ff9bc28dbec5a7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72c991a49ff3326d9897bb5e9a653543b3d6c6f54157c3bd185e22eb03a1e81e.jpeg",
  location: "Schiller Park, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 81,
  isInsider: true,
  description:
    "At SM Beauty, our team is composed of professional beauty and health experts who have studied and formulated beauty products to cater to all of our customers with naturally-derived, cruelty-free and non-GMO beauty cosmetics. We are proud to say that all of our products are available across over 500 stores worldwide for the everyday makeup artists and lovers. Our goal at SM Beauty is to serve all beauty enthusiasts with professional, high-quality and affordable products, and change the beauty industry with one face at a time. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.157Z",
    importedBy: "entity-db-cli",
  },
};
